import React, { useState, useEffect } from "react";
import { useGlobal } from "../context/ContenedorGlobal";
import "../styles/Formularios.css";
import InputSelectIp from "./InputSelectIp";
import InputSelectOcupDisp from "./InputSelectOcupDisp";
import InputSelectGenerico from "./InputSelectGenerico";
import { useApiFetch } from "../utils/apiFetch";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "../assets/logo_sict.png";

function GestionarIps() {

    const { subModuloActual, setSubModuloActual, setModuloActual, logout } = useGlobal();
    const [idIp, setIdIp] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [ipData, setIpData] = useState(null);

    const [paso1, setPaso1] = useState(true);
    const [paso2, setPaso2] = useState(false);

    const [pasoVb, setPasoVb] = useState(false);
    const [pasoDb, setPasoDb] = useState(false);
    const [pasoRs, setPasoRs] = useState(false);
    const [pasoRc, setPasoRc] = useState(false);
    const [pasoCe, setPasoCe] = useState(false);
    const [pasoEx, setPasoEx] = useState(false);

    const [estadoIp, setEstadoIp] = useState("");
    const [serieBien, setSerieBien] = useState("");
    const [servIpArray, setServIpArray] = useState(null);
    const [selectedServicios, setSelectedServicios] = useState([]);
    const [confiIpArray, setConfiIpArray] = useState(null);
    const [selectedConfi, setSelectedConfi] = useState([]);
    const [vistaLocal, setVistaLocal] = useState("formulario");
    const apiFetch = useApiFetch();
    const [resultados, setResultados] = useState([]);

    // Consultar IP seleccionada (solo una)
    const handleConsultarIp = async () => {
        setPaso1(false);

        try {
            const data = await apiFetch("consultar_ips.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id_ip: idIp })
            }, logout);

            if (data.status === "error") {
                setError("\u274C " + data.message);
                setTimeout(() => {
                    setPaso1(true);
                    setPaso2(false);
                }, 3000);
            } else {
                setSuccess("\u2705 Ip válida");
                setIpData(data);
                setPaso2(true); // siempre abre paso2 porque es una IP única
                setTimeout(() => setSuccess(""), 1000);
            }
        } catch (err) {
            setTimeout(() => setError("\u274C Error de conexión con el servidor"), 3000);
        }
    };

    // Consultar todas las IPs (sin abrir paso2)
    const handleConsultarTodas = async (exportar = null) => {
        try {
            const data = await apiFetch("consultar_ips.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id_ip: null }) // backend devuelve todas
            }, logout);

            if (data.status === "error") {
                setError("\u274C " + data.message);
                setTimeout(() => setError(""), 3000);
            } else {
                setResultados(data);
                setSuccess("\u2705 IPs consultadas correctamente");

                // Exportar directamente si se pidió
                if (exportar === "csv") exTodasCsv(data);
                if (exportar === "pdf") exTodasPdf(data);

                setTimeout(() => setSuccess(""), 1000);
            }
        } catch (err) {
            setTimeout(() => setError("\u274C Error de conexión con el servidor"), 3000);
        }
    };

    // Cambiar a formulario Vincular bien
    const handleCambVb = async (e) => {
        setPaso2(false);
        setPasoVb(true);
    };

    // Cambiar a formulario Desvincular bien
    const handleCambDb = async (e) => {
        setPaso2(false);
        setPasoDb(true);
    };

    // Cambiar a formulario Revocar servicio
    const handleCambRs = async (e) => {

        setPaso2(false);

        try {

            const data = await apiFetch("consultar_servicios_ip.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id_ip: idIp })
            }, logout);

            if (data.status === "ok") {
                setServIpArray(data.data);
                setPaso2(false);
                setPasoRs(true);

            } else {
                setError("\u274C " + (data.message || "No se encontraron servicios que revocar."));
                setTimeout(() => {
                    setError("");
                    setPaso1(true);
                }, 3000);
            }
        } catch (err) {
            setError("\u274C Error de conexión con el servidor");
            setTimeout(() => setError(""), 3000);
        }
    };

    // Cambiar a formulario Revocar configuración
    const handleCambRc = async (e) => {

        setPaso2(false);

        try {

            const data = await apiFetch("consultar_configuraciones_ip.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id_ip: idIp })
            }, logout);

            if (data.status === "ok") {
                setConfiIpArray(data.data);
                setPaso2(false);
                setPasoRc(true);

            } else {
                setError("\u274C " + (data.message || "No se encontraron configuraciones que revocar."));
                setTimeout(() => {
                    setError("");
                    setPaso1(true);
                }, 3000);
            }
        } catch (err) {
            setError("\u274C Error de conexión con el servidor");
            setTimeout(() => setError(""), 3000);
        }
    };

    // Cambiar a formulario Cambiar estado
    const handleCambCe = async (e) => {
        setPaso2(false);
        setPasoCe(true);
    };

    // Cambiar a formulario Exportar
    const handleCambEx = async (e) => {
        setPaso2(false);
        setPasoEx(true);
    };

    // Cancelar cualquier acción
    const handleCancelar = async (e) => {
        setPasoCe(false);
        setPasoVb(false);
        setPasoDb(false);
        setPasoRs(false);
        setPasoRc(false);
        setPaso1(true);
        setIdIp(null);
    };

    // Regresar a la vista paso2 para volver a mostrar la información de la ip
    const regresarAinfo = async (e) => {
        setPasoEx(false);
        setPaso2(true);
    };

    // Cambiar a formulario Exportar
    const handleBack = async (e) => {
        setPaso2(false);
        setPaso1(true);
        setIdIp(null);
    };

    // Función para vincular la ip al bien
    const handleVb = async (e) => {

        // Validar la existencia de una ip
        if (!idIp) {
            setError("\u274C Seleccione una ip válida");
            setTimeout(() => {
                setError("");
                setPaso1(true);
            }, 1500);
            return;
        }

        // Validar la existencia de una serie
        if (!serieBien) {
            setError("\u274C Seleccione una serie válida");
            setTimeout(() => {
                setError("");
                setPaso1(true);
            }, 1500);
            return;
        }

        try {

            const data = await apiFetch("vincular_bien.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id_ip: idIp, serie_bien: serieBien })
            }, logout);

            if (data.status === "ok") {
                setSuccess("\u2705 Vinculación exitosa");
                setPaso2(false);
                setPasoVb(false);
                setTimeout(() => {
                    setModuloActual("Software");
                    setSubModuloActual(null);
                }, 2000);
            } else {
                setError("\u274C " + (data.message || "Vinculación falló."));
                setTimeout(() => {
                    setError("");
                    setPaso1(true);
                }, 3000);
            }
        } catch (err) {
            setError("\u274C Error de conexión con el servidor");
            setTimeout(() => setError(""), 3000);
        }
    };

    // Función para Desvincular la ip del bien
    const handleDb = async (e) => {

        // Validar la existencia de una ip
        if (!idIp) {
            setError("\u274C Seleccione una ip válida");
            setTimeout(() => {
                setError("");
                setPaso1(true);
            }, 1500);
            return;
        }

        try {

            const data = await apiFetch("desvincular_bien.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id_ip: idIp })
            }, logout);

            if (data.status === "ok") {
                setSuccess("\u2705 Desvinculación exitosa");
                setPaso2(false);
                setPasoDb(false);
                setTimeout(() => {
                    setModuloActual("Software");
                    setSubModuloActual(null);
                }, 2000);
            } else {
                setError("\u274C " + (data.message || "Desvinculación falló."));
                setTimeout(() => {
                    setError("");
                    setPaso1(true);
                }, 3000);
            }
        } catch (err) {
            setError("\u274C Error de conexión con el servidor");
            setTimeout(() => setError(""), 3000);
        }


    };

    // Función para Revocar los servicios de la ip
    const handleRs = async (e) => {

        // Validar la existencia de una ip
        if (!idIp) {
            setError("\u274C Seleccione una ip válida");
            setTimeout(() => {
                setError("");
                setPaso1(true);
            }, 1500);
            return;
        }

        // Validar que almenos exista un registro
        if (selectedServicios.length === 0) {
            setError("\u274C No hay servicios seleccionados");
            setTimeout(() => {
                setError("");
                setPaso1(true);
            }, 1500);
            return;
        }

        try {

            const data = await apiFetch("revocar_servicios.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id_ip: idIp, id_servicios: selectedServicios })
            }, logout);

            if (data.status === "ok") {
                setSuccess("\u2705 Servicios revocados correctamente");
                // refrescar vista o resetear selección
                setSelectedServicios([]);
                setPaso2(false);
                setPasoRs(false);
                setTimeout(() => {
                    setModuloActual("Software");
                    setSubModuloActual("Gestionar IPs");
                }, 2000);
            } else {
                setError("\u274C " + (data.message || "Error al revocar servicios"));
                setTimeout(() => {
                    setError("");
                    setPaso1(true);
                }, 3000);
            }
        } catch (err) {
            setError("\u274C Error de conexión con el servidor");
            setTimeout(() => setError(""), 3000);
        }
    };

    // Función para actualizar los cambios en el array de elementos seleccionados en servicios
    const handleCheckboxChangeServicios = (e, item) => {
        if (e.target.checked) {
            setSelectedServicios([...selectedServicios, item.id_servicio]);
        } else {
            setSelectedServicios(selectedServicios.filter(id => id !== item.id_servicio));
        }
    };

    // Función para Revocar configuraciones de la ip
    const handleRc = async (e) => {

        // Validar la existencia de una ip
        if (!idIp) {
            setError("\u274C Seleccione una ip válida");
            setTimeout(() => {
                setError("");
                setPaso1(true);
            }, 1500);
            return;
        }

        // Validar que al menos exista un registro
        if (selectedConfi.length === 0) {
            setError("\u274C No hay configuraciones seleccionadas");
            setTimeout(() => {
                setError("");
                setPaso1(true);
            }, 1500);
            return;
        }

        try {

            const data = await apiFetch("revocar_configuraciones.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id_ip: idIp, id_confis: selectedConfi })
            }, logout);

            if (data.status === "ok") {
                setSuccess("\u2705 Configuración revacada correctamente");
                // refrescar vista
                setSelectedConfi([]);
                setPaso2(false);
                setPasoRc(false);
                setTimeout(() => {
                    setModuloActual("Software");
                    setSubModuloActual(null);
                }, 2000);
            } else {
                setError("\u274C " + (data.message || "Error al revocar configuración"));
                setTimeout(() => {
                    setError("");
                    setPaso1(true);
                }, 3000);
            }
        } catch (err) {
            setError("\u274C Error de conexión con el servidor");
            setTimeout(() => setError(""), 3000);
        }
    };

    // Función para actualizar los cambios en el array de elementos seleccionados en configuraciones
    const handleCheckboxChangeConfi = (e, item) => {
        if (e.target.checked) {
            setSelectedConfi([...selectedConfi, item.id_confi]);
        } else {
            setSelectedConfi(selectedConfi.filter(id => id !== item.id_confi));
        }
    };

    // Cambiar estado de una ip
    const handleCe = async (e) => {
        e.preventDefault();

        // Validar que exista un id_ip
        if (!idIp) {
            setError("\u274C Seleccione una IP válida");
            setTimeout(() => {
                setError("");
                setPaso1(true);
            }, 1500);
            return;
        }

        // Valida que exista un estado
        if (!estadoIp) {
            setError("\u274C No existe un estado válido");
            setTimeout(() => {
                setError("");
                setPaso1(true);
            }, 1500);
            return;
        }

        try {

            const data = await apiFetch("cambiar_estado_ip.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    id_ip: idIp,
                    estado_ip: estadoIp
                })
            }, logout);

            if (data.status === "ok") {
                setSuccess("\u2705 Estado actualizado correctamente");
                setPaso2(false);
                setPasoCe(false);
                setTimeout(() => {
                    setModuloActual("Software");
                    setSubModuloActual(null);
                }, 2000);
            } else {
                setError("\u274C " + (data.message || "No se pudo cambiar el estado."));
                setTimeout(() => {
                    setError("");
                }, 3000);
            }
        } catch (err) {
            setError("\u274C Error de conexión con el servidor");
            setTimeout(() => setError(""), 3000);
        }
    };

    // Exportar datos ip seleccionada en formato CSV
    const exIpCsv = (ipData) => {
        if (!ipData) return;

        // Encabezados
        const headers = ["ID IP", "IP", "Servicios Activos", "Configuraciones Activas", "Estado"];
        const row = [
            ipData.id_ip ?? "",
            ipData.ip ?? "",
            ipData.serv_activos ?? "",
            ipData.confi_activas ?? "",
            ipData.estado_ip ?? ""
        ];

        const csvRows = [];
        csvRows.push(headers.join(","));
        csvRows.push(row.join(","));

        const csvString = csvRows.join("\n");
        const BOM = "\uFEFF"; // UTF-8 BOM
        const blob = new Blob([BOM + csvString], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `ip_${ipData.id_ip}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // Exportar datos ip seleccionada en formato PDF
    const exIpPdf = (ipData) => {
        if (!ipData) return;

        const doc = new jsPDF();

        // Logo institucional
        doc.addImage(logo, "PNG", 10, 10, 30, 15);

        // Encabezado
        doc.setFontSize(14);
        doc.text("Secretaría de Infraestructura, Comunicaciones y Transportes", 50, 20);
        doc.setFontSize(12);
        doc.text("Reporte de IP", 50, 30);

        doc.setLineWidth(0.5);
        doc.line(10, 40, 200, 40);

        // Tabla con los datos de la IP
        autoTable(doc, {
            startY: 50,
            head: [["ID IP", "IP", "Servicios Activos", "Configuraciones Activas", "Estado"]],
            body: [[
                ipData.id_ip ?? "",
                ipData.ip ?? "",
                ipData.serv_activos ?? "",
                ipData.confi_activas ?? "",
                ipData.estado_ip ?? ""
            ]]
        });

        // Pie de página
        doc.setFontSize(10);
        doc.text("© 2026 SIGBI-712. Todos los derechos reservados.", 10, 290);

        doc.save(`ip_${ipData.id_ip}.pdf`);
    };

    // Exportar datos de todas las ip en formato CSV
    const exTodasCsv = (ips) => {
        if (!ips || !ips.length) return;

        const headers = ["ID IP", "IP", "Servicios Activos", "Configuraciones Activas", "Estado"];
        const rows = ips.map(ip => [
            ip.id_ip ?? "",
            ip.ip ?? "",
            ip.serv_activos ?? "",
            ip.confi_activas ?? "",
            ip.estado_ip ?? ""
        ]);

        const csvRows = [];
        csvRows.push(headers.join(","));
        rows.forEach(row => csvRows.push(row.join(",")));

        const csvString = csvRows.join("\n");
        const BOM = "\uFEFF"; // UTF-8 BOM
        const blob = new Blob([BOM + csvString], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "ips.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    // Exportar datos de todas las ip en formato PDF
    const exTodasPdf = (ips) => {
        if (!ips || !ips.length) return;

        const doc = new jsPDF();

        // Logo institucional
        doc.addImage(logo, "PNG", 10, 10, 30, 15);

        // Encabezado
        doc.setFontSize(14);
        doc.text("Secretaría de Infraestructura, Comunicaciones y Transportes", 50, 20);
        doc.setFontSize(12);
        doc.text("Listado de IPs", 50, 30);

        doc.setLineWidth(0.5);
        doc.line(10, 40, 200, 40);

        // Tabla con todas las IPs
        autoTable(doc, {
            startY: 50,
            head: [["ID IP", "IP", "Servicios Activos", "Configuraciones Activas", "Estado"]],
            body: ips.map(ip => [
                ip.id_ip ?? "",
                ip.ip ?? "",
                ip.serv_activos ?? "",
                ip.confi_activas ?? "",
                ip.estado_ip ?? ""
            ])
        });

        // Pie de página
        doc.setFontSize(10);
        doc.text("© 2026 SIGBI-712. Todos los derechos reservados.", 10, 290);

        doc.save("ips.pdf");
    };


    return (
        <div className="sesion-form">
            <>
                {error && <div className="error">{error}</div>}
                {success && <div className="success">{success}</div>}
            </>

            {paso1 && (
                <>
                    <InputSelectIp
                        idIp={idIp}
                        setIdIp={setIdIp}
                        estadoFiltro=""
                        label="Seleccione una ip"
                    />

                    <div className="form-buttons">
                        <button type="button" onClick={handleConsultarIp}>
                            Consultar
                        </button>
                    </div>
                </>
            )}

            {paso2 && ipData && (
                <>
                    <table className="tabla-estandar seleccion-unica">
                        <thead>
                            <tr>
                                {/*<th></th>*/}
                                <th>Ip</th>
                                <th>Servicios<br />Activos</th>
                                <th>Configuraciones<br />Activas</th>
                                <th>Estado</th>
                            </tr>
                        </thead>
                        <tbody>
                            {ipData && (
                                <tr>
                                    {/*<td data-label="Seleccionar">
                                        <input
                                            type="checkbox"
                                            checked={idIp === ipData.id_ip}
                                            onChange={() => setIdIp(ipData.id_ip)}
                                        />
                                    </td>*/}
                                    <td data-label="Ip">{ipData.ip}</td>
                                    <td data-label="Servicios">{ipData.serv_activos}</td>
                                    <td data-label="Configuraciones">{ipData.confi_activas}</td>
                                    <td data-label="Estado">{ipData.estado_ip}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                    <div className="form-buttons">
                        <button
                            type="button"
                            onClick={handleCambVb}
                            disabled={!ipData || ipData.estado_ip === "OCUPADA"}
                        >
                            Vincular<br />con bien
                        </button>

                        <button
                            type="button"
                            onClick={handleCambDb}
                            disabled={!ipData || ipData.estado_ip === "DISPONIBLE"}
                        >
                            Desvincular<br />del bien
                        </button>

                        <button
                            type="button"
                            onClick={handleCambRs}
                            disabled={
                                !ipData || !ipData.serv_activos || ipData.serv_activos === "NO" // Deshabilitar el boton si se cumple cualquiera de estas tres condiciones
                            }
                        >
                            Revocar<br />servicio
                        </button>

                        <button
                            type="button"
                            onClick={handleCambRc}
                            disabled={!ipData || !ipData.confi_activas}
                        >
                            Revocar<br />configuración
                        </button>

                        <button
                            type="button"
                            onClick={handleCambCe}
                            disabled={!ipData}
                        >
                            Cambiar<br />estado
                        </button>

                        <button
                            type="button"
                            onClick={handleCambEx}
                            disabled={!ipData}
                        >
                            Exportar
                        </button>

                        <button type="button" onClick={handleBack}>
                            Regresar
                        </button>
                    </div>
                </>
            )}

            {pasoVb && (
                <>
                    <h2>Vincular bien con la ip: {ipData.ip}</h2>
                    <InputSelectGenerico
                        idSeleccionado={serieBien}
                        setIdSeleccionado={setSerieBien}
                        label="Seleccione el bien"
                        apiUrl={`consultar_bienes.php`}
                        valueField="serie_bien"
                        displayField={(o) => `${o.serie_bien}---------${o.a_paterno} ${o.a_materno} ${o.usuario}`}
                        readOnly={false}
                        showDefaultOption={true}
                        defaultOptionText="Seleccione un bien"
                    />
                    <div className="acciones">
                        <button type="button" onClick={handleVb}>Vincular</button>
                        <button type="button" onClick={handleCancelar}>Cancelar</button>
                    </div>
                </>
            )}

            {pasoDb && (
                <>
                    <h2>Desvincular ip</h2>
                    <p>
                        ¿Seguro que deseas desvincular la ip <strong>{ipData.ip}</strong> del bien.
                    </p>
                    <div className="acciones">
                        <button type="button" onClick={handleDb}>Desvincular</button>
                        <button type="button" onClick={handleCancelar}>Cancelar</button>
                    </div>
                </>
            )}

            {pasoRs && (
                <>
                    <h2>Sevicios asignados a la ip {ipData.ip}</h2>
                    <table className="tabla-estandar seleccion-unica">
                        <thead>
                            <tr>
                                <th>Seleccionar</th>
                                <th>Id Servicio</th>
                                <th>Servicio</th>
                            </tr>
                        </thead>
                        <tbody>
                            {servIpArray.map((item) => (
                                <tr key={item.id_servicio}>
                                    <td>
                                        <input
                                            type="checkbox"
                                            value={item.id_servicio}
                                            onChange={(e) => handleCheckboxChangeServicios(e, item)}
                                        />
                                    </td>
                                    <td>{item.id_servicio}</td>
                                    <td>{item.servicio}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div className="acciones">
                        <button type="button" onClick={handleRs} disabled={selectedServicios.length === 0}
                        >Revocar servicios</button>
                        <button type="button" onClick={handleCancelar}>Cancelar</button>
                    </div>
                </>
            )}

            {pasoRc && (
                <>
                    <h2>Configuraciones asignadas a la ip {ipData.ip}</h2>
                    <table className="tabla-estandar seleccion-unica">
                        <thead>
                            <tr>
                                <th>Seleccionar</th>
                                <th>Id Configuración</th>
                                <th>Configuración</th>
                            </tr>
                        </thead>
                        <tbody>
                            {confiIpArray.map((item) => (
                                <tr key={item.id_confi}>
                                    <td>
                                        <input
                                            type="checkbox"
                                            value={item.id_confi}
                                            onChange={(e) => handleCheckboxChangeConfi(e, item)}
                                        />
                                    </td>
                                    <td>{item.id_confi}</td>
                                    <td>{item.confi}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div className="acciones">
                        <button type="button" onClick={handleRc} disabled={selectedConfi.length === 0}
                        >Revocar configuraciones</button>
                        <button type="button" onClick={handleCancelar}>Cancelar</button>
                    </div>
                </>
            )}

            {pasoCe && (
                <>
                    <h2>Cambiar estado de la ip {ipData.ip}</h2>
                    <InputSelectOcupDisp
                        value={estadoIp}
                        setValue={setEstadoIp}
                        label="Seleccione un estado para la ip"
                        current={ipData.estado_ip}
                    />
                    <div className="acciones">
                        <button type="button" onClick={handleCe}>Cambiar estado</button>
                        <button type="button" onClick={handleCancelar}>Cancelar</button>
                    </div>
                </>
            )}

            {pasoEx && (
                <>
                    <h2>Exportar ip actual: {ipData.ip}</h2>
                    <div className="form-buttons">
                        <button className="exportar" onClick={() => exIpCsv(ipData)}>
                            Exportar<br></br>en CSV
                        </button>
                        <button className="exportar" onClick={() => exIpPdf(ipData)}>
                            Exportar<br></br>en PDF
                        </button>
                    </div>

                    <h2>Exportar todas las ip</h2>
                    <div className="form-buttons">
                        {/* Exportar todas las IPs */}
                        <button
                            className="exportar"
                            onClick={() => handleConsultarTodas("csv")}
                        >
                            Exportar<br></br>en CSV
                        </button>

                        <button
                            className="exportar"
                            onClick={() => handleConsultarTodas("pdf")}
                        >
                            Exportar<br></br>en PDF
                        </button>

                    </div>

                    <div className="form-buttons">
                        <button type="button" onClick={regresarAinfo}>Regresar</button>
                    </div>
                </>
            )}

        </div>
    );
}

export default GestionarIps;